type IconProps = { className?: string };

export function HvacIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="32"
      height="32"
      className={className}
      aria-hidden
    >
      <path
        fill="currentColor"
        d="M8 11c1.126 0 2.164.372 3 1a4.992 4.992 0 0 0-2 4c0 1.636.786 3.088 2 4a5 5 0 1 1-3-9Zm12 2a5 5 0 1 1-8 0 4.993 4.993 0 0 0 4 2 4.993 4.993 0 0 0 4-2ZM16 3a5 5 0 1 1-3 9 4.993 4.993 0 0 0 2-4 4.993 4.993 0 0 0-2-4c.836-.628 1.874-1 3-1ZM8 3a5 5 0 0 1 4 8 4.992 4.992 0 0 0-4-2 4.992 4.992 0 0 0-4 2 5 5 0 0 1 4-8Z"
      />
    </svg>
  );
}

export function RoofingIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="32"
      height="32"
      viewBox="0 0 256 256"
      className={className}
      aria-hidden
    >
      <path d="M247.16,124.42l-40-80A8,8,0,0,0,200,40H56a8,8,0,0,0-7.16,4.42l-40,80A8.08,8.08,0,0,0,8,128v56a16,16,0,0,0,16,16H232a16,16,0,0,0,16-16V128A8.08,8.08,0,0,0,247.16,124.42ZM99.06,56l12,24H80.94l-12-24Zm48,0,12,24H128.94l-12-24Zm-46.12,64-12-24h30.12l12,24Zm48,0-12-24h30.12l12,24Zm48,0-12-24h30.12l12,24Zm10.12-40H176.94l-12-24h30.12ZM104,184V136H232v48Z" />
    </svg>
  );
}

export function PlumbingIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M15.0402 7.75996L14.3302 8.46996L13.6202 9.17996L10.4402 5.99996C9.85021 5.39996 8.90021 5.39996 8.32021 5.98996C7.73021 6.57996 7.73021 7.52996 8.32021 8.10996L11.5002 11.29L10.7902 12L4.43021 18.36C3.65021 19.14 3.65021 20.41 4.43021 21.19C5.21021 21.97 6.48022 21.97 7.26022 21.19L16.4502 12C16.8402 12.39 17.4702 12.39 17.8602 12C18.2502 11.61 18.2502 10.98 17.8602 10.59L15.0402 7.75996Z"
        fill="currentColor"
      />
      <path
        d="M5.49035 13.7699C6.08035 14.3599 7.03035 14.3599 7.61035 13.7699L10.0804 11.2999L7.96035 9.16992L5.49035 11.6399C4.90035 12.2299 4.90035 13.1799 5.49035 13.7699Z"
        fill="currentColor"
      />
      <path
        d="M19.28 4.92998L17.16 2.80998C16.38 2.02998 15.11 2.02998 14.33 2.80998L11.5 5.63998L13.62 7.75998L15.74 5.63998L19.28 9.17998C20.45 7.99998 20.45 6.09998 19.28 4.92998Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PestControlIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M21.31 17.38L18.92 15.25C19.44 12.89 17.56 11 15.5 11C14.34 11 12 11.9 12 14.5C12 15.47 12.39 16.34 13.03 16.97L12.32 17.68C11.5 16.87 11 15.74 11 14.5C11 12.8 11.96 11.33 13.35 10.57C12.65 10.21 11.87 10 11.07 10C8.69 10 6.7 11.65 6.16 13.87C4.91 13.5 4 12.36 4 11C4 9.34 5.34 8 7 8C7.94 8 8.56 8 9.5 8C10.88 8 12 6.88 12 5.5C12 4.12 10.88 3 9.5 3H8C7.45 3 7 3.45 7 4C7 4.55 7.45 5 8 5H9.5C9.78 5 10 5.22 10 5.5C10 5.78 9.78 6 9.5 6C9.47 6 9 6 7 6C4.24 6 2 8.24 2 11C2 13.42 3.72 15.44 6 15.9V15.93C6 18.73 8.27 21 11.07 21H19.93C21.8 21 22.74 18.66 21.31 17.38ZM18 19C17.45 19 17 18.55 17 18C17 17.45 17.45 17 18 17C18.55 17 19 17.45 19 18C19 18.55 18.55 19 18 19Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function GutterCleaningIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="32"
      height="32"
      viewBox="0 0 256 256"
      className={className}
      aria-hidden
    >
      <path d="M215.52,213.26,164.51,73l9.09-25H184a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16h4.58L32.48,213.26a8,8,0,0,0,4.79,10.26A8.14,8.14,0,0,0,40,224a8,8,0,0,0,7.52-5.27L57.24,192h47l-7.74,21.26a8,8,0,0,0,4.79,10.26A8.14,8.14,0,0,0,104,224a8,8,0,0,0,7.52-5.27L130,168H182l18.45,50.73A8,8,0,0,0,208,224a8.14,8.14,0,0,0,2.73-.48A8,8,0,0,0,215.52,213.26ZM109.39,64h30a8,8,0,0,1,0,16H109.39a8,8,0,1,1,0-16Zm.86,96H80.3a8,8,0,0,1,0-16h30a8,8,0,0,1,0,16Zm14.54-40H94.84a8,8,0,0,1,0-16h30a8,8,0,0,1,0,16Zm11,32L156,96.41,176.21,152Z" />
    </svg>
  );
}

export function PaintingIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="32"
      height="32"
      viewBox="0 0 56 56"
      className={className}
      aria-hidden
    >
      <path d="M 19.3164 22.7383 L 34.9726 38.3945 C 36.7305 40.1523 38.5586 39.8711 40.1992 38.2305 L 51.8242 26.6523 C 53.4649 25.0117 53.7226 23.1836 51.9649 21.4258 L 49.5975 19.0820 C 46.8087 21.5664 38.9805 27.1445 37.7617 25.9258 C 37.3633 25.5274 37.6914 25.1758 37.9258 24.9414 C 40.5039 22.2930 43.9492 18.0742 44.3946 13.8320 L 32.0430 1.4805 C 30.5899 .4 28.4336 .8 27.2617 1.7383 C 24.8946 5.0898 24.9414 10.6914 19.3164 17.3945 C 17.7695 19.2695 17.5117 20.9336 19.3164 22.7383 Z M 5.4883 52.8320 C 8.5821 55.8789 12.4726 55.9726 15.2383 53.2070 C 17.4180 51.0508 19.6914 45.2617 21.2617 42.5664 L 27.8242 49.1055 C 29.6992 50.9805 31.7852 51.0274 33.5430 49.2695 L 35.0195 47.7695 C 36.7773 46.0117 36.7305 43.9258 34.8789 42.0508 L 16.2930 23.4648 C 14.4180 21.5664 12.3555 21.5195 10.5742 23.3242 L 9.0977 24.8008 C 7.2930 26.5820 7.3399 28.6211 9.2383 30.5195 L 15.7539 37.0586 C 13.0821 38.6289 7.2695 40.9258 5.1133 43.0820 C 2.2774 45.8945 2.4180 49.8086 5.4883 52.8320 Z M 8.6758 49.5273 C 7.9024 48.7305 7.8789 47.4648 8.6758 46.6680 C 9.4961 45.8711 10.7617 45.8711 11.5586 46.6680 C 12.3555 47.4883 12.3555 48.7070 11.5586 49.5273 C 10.7617 50.3476 9.4961 50.3711 8.6758 49.5273 Z" />
    </svg>
  );
}

export function CarpetCleaningIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 512 512"
      className={className}
      aria-hidden
    >
      <path
        fill="currentColor"
        d="M152.718 28.524c-1.546-.001-3.09.01-4.63.032-20.528.29-40.464 2.677-58.374 7.902-28.656 8.36-52.804 24.703-62.717 51.734-8.846 24.123-1.132 46.174 14.352 63.112 15.483 16.938 38.137 30.613 62.14 44.273 24.004 13.66 49.415 27.172 70.094 42.21 20.68 15.037 36.234 31.401 42.22 50.093 1.124 3.506.276 14.454-1.921 23.44-.876 3.58-1.808 6.718-2.65 9.408l17.546 4.234c.84-2.748 1.747-5.924 2.588-9.365 2.488-10.175 5.153-22.05 1.58-33.207-7.773-24.272-26.598-43.033-48.777-59.16-22.179-16.128-48.104-29.824-71.775-43.295-23.672-13.471-45.032-26.852-57.76-40.776-12.728-13.923-17.423-26.537-10.736-44.77 7.498-20.448 25.514-33.257 50.857-40.652 25.343-7.394 57.333-8.66 88.924-5.681 31.59 2.98 62.835 10.149 86.8 18.886 10.344 3.771 19.325 7.848 26.303 11.858 3.216-2.397 6.614-4.797 10.184-6.94 2.174-1.305 4.44-2.527 6.808-3.582a108.01 108.01 0 0 0-4.23-2.812c-8.89-5.594-20.05-10.75-32.898-15.434-25.697-9.368-58.118-16.77-91.276-19.898-10.88-1.026-21.832-1.6-32.652-1.61zm175.904 54.288c-.362.012-.732.038-1.115.076-3.062.3-6.985 1.828-11.276 4.404-6.12 3.675-12.542 9.225-19.238 14.213l62.45 84.068 20.247-4.746c-4.262-30.338-14.22-72.644-43.539-95.263-2.891-2.231-4.996-2.837-7.529-2.752zm52.8 116.097l-17.523 4.108 50.264 214.459h18.488zM57.403 318.597l-1.965 18.478c5.836.202 11.85.48 18.011.834l1.852-17.408zm123.183 13.252l-4.99 18.357 60.283 14.621 5.502-18.306zm-146.85 22.818c-.934 0-1.105-.1-2.558 1.904-1.453 2.004-3.197 6.092-4.41 11.504-2.428 10.824-3.016 26.644-2.05 42.448.967 15.803 3.432 31.755 6.468 43.209 1.517 5.726 3.24 10.363 4.588 12.89.299.561.328.53.55.854h9.295a56.513 56.513 0 0 1-4.883-23c0-31.374 25.627-57 57-57 31.374 0 57 25.626 57 57a56.513 56.513 0 0 1-4.882 23h90.515c.458-.604 1.316-1.987 2.149-4.3 1.8-5.002 3.313-13.058 4.273-21.694 1.92-17.273 1.945-37.006 1.945-45.006 0-.625-.316-2.017-3.265-4.594-2.95-2.577-8.16-5.655-15.002-8.56-13.686-5.812-33.77-11.127-56.406-15.409-45.271-8.564-101.032-13.246-140.327-13.246zm64 50.809c-21.645 0-39 17.354-39 39 0 21.645 17.355 39 39 39 21.646 0 39-17.355 39-39 0-21.646-17.354-39-39-39zm309.563 30l-7 14h50.875l-7-14zm-44.563 32v14h126v-14z"
      />
    </svg>
  );
}

export function LawnCareIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 512 512"
      className={className}
      aria-hidden
    >
      <path
        fill="currentColor"
        d="M139.8 24.96C155.9 88.06 182 124.7 197 141.5l1.2 1.3 1.6.9c16.4 8 26.8 24.7 26.8 43 0 26.6-21.4 48-48.1 48-26.6 0-48-21.4-48-48 0-8.6 2.3-16.9 6.6-24.4l2.9-5-3.2-4.9c-18.1-27.1-19.7-51.4-14.6-76.74 3.3-16.6 10.2-33.6 17.6-50.7zm121 114.64c7.6.1 14.9 1.3 20.9 4 4 8.1 6.2 18.7 10.6 29.1 2.5 5.6 5.9 11.4 11.6 15.6 5.4 4 12.5 6.1 20.4 6 56.5 10.3 92.3 26.4 116.3 45.4 24.2 18.9 37 40.9 46.9 64.8v.1c1.7 3.9 1.3 6.4-.1 9.2-1.5 3-4.6 6-8.4 8.1-3.9 2.1-8.5 3.1-12.1 3-3.5-.2-5.8-1.3-7.4-3.1-12.2-14.9-27-35.3-45.5-51.7-18.6-16.4-41.9-29.1-69.5-25.9-21.2 2.4-33.1-6.4-50.4-16.8-13.5-8.1-30.1-16.6-52.9-17.6 2.7-7.2 4.2-15 4.2-23.1 0-16.3-6-31.6-16.2-43.5 5.6-1 11.7-2.3 18.1-3 3.4-.3 6.8-.6 10.2-.6zM23.39 156.8c27.5 9.1 56.6 17.2 90.11 14.8-1.1 4.9-1.8 10-1.8 15.1 0 15.4 5.4 29.7 14.2 41.1-28.81-.2-48.71-10.4-66.11-26.2-13.3-12.2-24.9-28.2-36.4-44.8zm155.11 3.8c-14.3 0-26.1 11.8-26.1 26.1s11.8 26.1 26.1 26.1 26.1-11.8 26.1-26.1-11.8-26.1-26.1-26.1zm0 18.8c4.2 0 7.4 3.1 7.4 7.3 0 4.1-3.2 7.3-7.4 7.3-4.1 0-7.3-3.2-7.3-7.3 0-4.2 3.2-7.3 7.3-7.3zm25.8 69c6.3 52.6 26.9 87.3 51.2 113.8 26.8 29.2 57.1 49.7 78.7 77.3 1.2 3.3 2 10.1 1.2 17.3-1 7.7-3.5 16-6.9 21.8-3.4 5.6-6.9 8.1-10.1 8.4-3 .3-8.6-1.3-17-10.5-18-33.3-53.7-84.8-100.9-107.4-18.7-9-27.6-21.7-32.3-37-4.6-15.2-4.5-33.2-2.9-50.1 1.2-13.9-1.5-23.8-4.7-31 5.7 1.7 11.7 2.5 17.9 2.5 9.1 0 17.9-1.9 25.8-5.1z"
      />
    </svg>
  );
}

export function PoolCleaningIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 15 15"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M7.43931 13.4416C6.54499 13.9461 5.56317 14.5 3.95454 14.5C2.47163 14.5 1.34063 13.7381 0.625824 12.9317L1.37417 12.2683C1.95937 12.9286 2.83745 13.5 3.95454 13.5C5.29393 13.5 6.0834 13.0584 6.95888 12.5645L6.96977 12.5584C7.8641 12.0539 8.84591 11.5 10.4545 11.5C11.9851 11.5 13.3377 12.3202 14.3064 13.0716L13.6936 13.8618C12.7714 13.1465 11.6421 12.5 10.4545 12.5C9.11516 12.5 8.32568 12.9416 7.4502 13.4355L7.43931 13.4416Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.63639 1C4.14922 1 3 2.20269 3 3.72724V4H9V3.63639C9 1.56904 10.6333 0 12.6818 0V1C11.1667 1 10 2.14011 10 3.63639V10H9V9H3V12H2V3.72724C2 1.68816 3.55993 0 5.63639 0V1ZM3 8H9V5H3V8Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PetcareIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M17.34 14.86C16.47 13.84 15.74 12.97 14.86 11.95C14.4 11.41 13.81 10.87 13.11 10.63C13 10.59 12.89 10.56 12.78 10.54C12.53 10.5 12.26 10.5 12 10.5C11.74 10.5 11.47 10.5 11.21 10.55C11.1 10.57 10.99 10.6 10.88 10.64C10.18 10.88 9.60002 11.42 9.13002 11.96C8.26002 12.98 7.53002 13.85 6.65002 14.87C5.34002 16.18 3.73002 17.63 4.03002 19.66C4.32002 20.68 5.05002 21.69 6.36002 21.98C7.09002 22.13 9.42002 21.54 11.9 21.54H12.08C14.56 21.54 16.89 22.12 17.62 21.98C18.93 21.69 19.66 20.67 19.95 19.66C20.26 17.62 18.65 16.17 17.34 14.86Z"
        fill="currentColor"
      />
      <path
        d="M19.5 12C20.8807 12 22 10.8807 22 9.5C22 8.11929 20.8807 7 19.5 7C18.1193 7 17 8.11929 17 9.5C17 10.8807 18.1193 12 19.5 12Z"
        fill="currentColor"
      />
      <path
        d="M15 8C16.3807 8 17.5 6.88071 17.5 5.5C17.5 4.11929 16.3807 3 15 3C13.6193 3 12.5 4.11929 12.5 5.5C12.5 6.88071 13.6193 8 15 8Z"
        fill="currentColor"
      />
      <path
        d="M9 8C10.3807 8 11.5 6.88071 11.5 5.5C11.5 4.11929 10.3807 3 9 3C7.61929 3 6.5 4.11929 6.5 5.5C6.5 6.88071 7.61929 8 9 8Z"
        fill="currentColor"
      />
      <path
        d="M4.5 12C5.88071 12 7 10.8807 7 9.5C7 8.11929 5.88071 7 4.5 7C3.11929 7 2 8.11929 2 9.5C2 10.8807 3.11929 12 4.5 12Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MovingIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 512 512"
      className={className}
      aria-hidden
    >
      <path
        fill="currentColor"
        d="M61.39 25.39C93.9 58.33 115.8 96.55 133.3 134.5c4.9-12 7.3-22.2 18.9-32.3 47 26.5 60.3 43.3 64.4 80.4h66.8c1.8-36 7.6-56.3 36.5-82.81 15.9 12.41 20 26.91 28.1 40.71 8.5-38.9 37.3-81.28 76.7-101.89-52.5-11.56-108.5-.43-153.3 17.54 9.3 6.39 22.7 11.23 26.9 19.5-19 9.79-39.5 42.35-51.2 69.35-14.1-25.1-43.5-53.44-72-67.64 11.5-11.58 23-15.79 34.5-22.89C176.6 36.1 117.5 27 61.39 25.39zm8.85 175.21l-41.25 110H137.8l41.2-110zm134.76 0l41.2 110H483l-41.2-110zm-22 40.6l-32.8 87.4H73v158h110zm18 0v245.4h238v-158H233.8z"
      />
    </svg>
  );
}

export function DeckPatioIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d="M19.1 16H15V22H17V18H18.98L19 22H21V16.74L21.82 12.37L19.86 12L19.1 16Z"
        fill="currentColor"
      />
      <path
        d="M4.13993 12L2.17993 12.37L2.99993 16.74V22H4.99993L5.01993 18H6.99993V22H8.99993V16H4.89993L4.13993 12Z"
        fill="currentColor"
      />
      <path
        d="M22 9L12 2L2 9H11V22H13V9H22Z"
        fill="currentColor"
      />
    </svg>
  );
}
